import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import { motion } from 'framer-motion';

// UI
import { Typography } from '@components/typography';
import { Icon, IconNames } from '@components/icon';
const steps = [{
  icon: IconNames.LINK,
  title: 'Share Your Code',
  description: 'Send your unique referral code via email, text, or social media.'
}, {
  icon: IconNames.HOUSE_CIRCLE_CHECK,
  title: 'Friends Sign Up',
  description: 'Your friend uses your code to create their Savvy account.'
}, {
  icon: IconNames.SACK_DOLLAR,
  title: 'You Both Earn',
  description: "You'll both earn $50 cash back on your next stay."
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export const HowItWorks: React.FC = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: "-50px"
    }} transition={{
      duration: 0.5
    }}><Typography variant="title4" component="h2" className="text-center mb-8">How It Works</Typography></motion.div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      once: true,
      margin: "-50px"
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="py-12 bg-white"><div className="body-container">{t0}<motion.div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-[1000px] mx-auto" initial="hidden" whileInView="visible" viewport={t1} variants={containerVariants}>{steps.map(_temp)}</motion.div></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(step, index) {
  return <motion.div key={index} className="flex flex-col items-center text-center px-8 gap-3 rounded-2xl" variants={itemVariants}><Icon name={step.icon} size="2x" className="text-secondary-main" /><Typography variant="title5" component="h3">{step.title}</Typography><Typography variant="body1" component="p" className="font-light leading-normal">{step.description}</Typography></motion.div>;
}